export default {
  list: (state) => state.list,
  selected: (state) => state.selected,
};
